export default {"src":"/_next/static/media/basic_collabo_banner.e73cc24a.svg","height":400,"width":560,"blurWidth":0,"blurHeight":0};